var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResendPrivacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.659,
    height: 14.139,
    viewBox: "0 0 30.659 14.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6253",
    "data-name": "Group 6253",
    transform: "translate(0 -137.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47496",
    "data-name": "Path 47496",
    d: "M161.923,137.938l9.874,7.145,9.874-7.145Z",
    transform: "translate(-152.227)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47497",
    "data-name": "Path 47497",
    d: "M72.277,168.725a.918.918,0,0,1-1.076,0L60.65,161.09v.947H56.41a.918.918,0,0,0,0,1.835h4.24v5.8H56.41a.918.918,0,1,0,0,1.835h4.24v1.415a.918.918,0,0,0,.918.918H81.911a.918.918,0,0,0,.918-.918V161.09l-10.551,7.635Z",
    transform: "translate(-52.169 -21.766)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47498",
    "data-name": "Path 47498",
    d: "M6.076,240.675H.918a.918.918,0,1,0,0,1.835H6.076a.918.918,0,1,0,0-1.835Z",
    transform: "translate(0 -96.585)",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendPrivacy);
export default __webpack_public_path__ + "static/media/resend-privacy.3b2fb1a9094b976d5f8b2a4d3b4b340f.svg";
export { ForwardRef as ReactComponent };